import React, { Fragment } from "react";
import ReactHtmlParser from "react-html-parser";
import markdownIt from "markdown-it";
import mila from "markdown-it-link-attributes";

const INTERNAL_IFRAME_PREFIX = "https://chatapps";

function getHostname(location) {
  if (!location) return "";
  if (typeof location === "object" && location.hostname) {
    return location.hostname;
  }
  if (typeof location === "string" && location.trim() !== "") {
    try {
      return new URL(location).hostname;
    } catch {
      return "";
    }
  }
  return "";
}

function createMarkdown(MAIN_WEBSITE_DOMAIN) {
  const md = markdownIt({
    html: true,
    linkify: true,
    typographer: true,
  });

  md.use(mila, [
    // Internal iframe links
    {
      matcher(href) {
        return href.toLowerCase().startsWith(INTERNAL_IFRAME_PREFIX);
      },
      attrs: {
        rel: "noopener",
        class: "internal-link",
      },
    },
    // Same-domain links
    {
      matcher(href) {
        return (
          MAIN_WEBSITE_DOMAIN &&
          href.toLowerCase().includes(MAIN_WEBSITE_DOMAIN.toLowerCase())
        );
      },
      attrs: {
        target: "_top",
        rel: "noopener",
        class: "same-domain-link",
      },
    },

    // External links
    {
      matcher(href) {
        const lower = href.toLowerCase();
        return (
          !lower.startsWith(INTERNAL_IFRAME_PREFIX) &&
          !lower.includes(MAIN_WEBSITE_DOMAIN.toLowerCase())
        );
      },
      attrs: {
        target: "_blank",
        rel: "noopener",
        class: "external-link",
      },
    },
  ]);

  return md;
}

export default function CustomMessage({
  content,
  messageId,
  conversationId,
  iid,
  replyToId,
  cardActivitiesSummary,
  inZenDesk,
  location,
  googleAnalytics, 
}) {
  const MAIN_WEBSITE_DOMAIN = getHostname(location);
  const md = createMarkdown(MAIN_WEBSITE_DOMAIN);
  let feedback_response = JSON.parse(
    localStorage.getItem(iid + "-chatfeedback")
  );
  let feedbackbody;
  if (feedback_response !== null) {
    feedbackbody = feedback_response.filter(
      (i) => i.messageId === messageId
    )[0];
  }

function appendUTM(url) {
  console.log('utm:', url, googleAnalytics )
  if (!googleAnalytics) return url;
  if (url.includes("utm_source")) return url;

  const utmSource = googleAnalytics?.utmSource || "Myma";
  const utmMedium = googleAnalytics?.utmMedium || "Chatbot";

  try {
    const parsed = new URL(url);
    parsed.searchParams.set("utm_source", utmSource);
    parsed.searchParams.set("utm_medium", utmMedium);
    return parsed.toString();
  } catch {
    return `${url}?utm_source=${utmSource}&utm_medium=${utmMedium}`;
  }
}
function handleLinkClick(e) {
  const anchor = e.target.closest("a");
  if (!anchor || !anchor.href) return;

  // Ignore internal iframe links
  if (anchor.href.startsWith(INTERNAL_IFRAME_PREFIX)) return;
  e.preventDefault();
  e.stopPropagation();

  const finalUrl = appendUTM(anchor.href);
  console.log("Opening URL with UTMs:", finalUrl);

  const target = anchor.getAttribute("target");

  if (target === "_blank") {
    window.open(finalUrl, "_blank", "noopener");
  } else if (window.parent) {
    window.parent.postMessage(`openUrl:${finalUrl}`, "*");
  } else {
    window.location.href = finalUrl;
  }
}
  return (
    <div
      className="markdown"
      onClickCapture={handleLinkClick}
      data-activity-id={messageId}
      text-len={content?.length}
      data-con-id={conversationId}
      width={content?.length > 50 ? "true" : "false"}
      data-feedback={feedbackbody !== undefined && feedbackbody.feedback}
      data-view-btn={replyToId}
      data-msg-type={cardActivitiesSummary}
      data-inzendesk={inZenDesk}
    >
      {content &&
        content.split("\n").map(
          (item, key) =>
            item !== "" && (
              <Fragment key={key}>
                {ReactHtmlParser(md.render(item))}
              </Fragment>
            )
        )}
    </div>
  );
}
